import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FP } from "./tokens";

// FinancePro hero block used on top of "search/filter" pages.
// It renders the title + supporting copy and centers a children area (where the
// page passes its own search field + action button so existing handlers stay intact).
export default function HeroSearch({ title, description, children, dense = false }) {
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: 2.5,
        border: `1px solid ${FP.color.border}`,
        bgcolor: FP.color.cardBg,
        boxShadow: FP.shadow.soft,
        overflow: "hidden",
        mb: 3,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(1200px 320px at 90% -50%, rgba(27,108,251,0.10), transparent 60%), radial-gradient(800px 240px at -10% 130%, rgba(14,31,51,0.06), transparent 60%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "relative",
          textAlign: "center",
          px: { xs: 2.5, md: 5 },
          py: { xs: dense ? 3 : 4, md: dense ? 3.5 : 5 },
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.05rem", md: "1.18rem" },
            color: FP.color.textPrimary,
            letterSpacing: "-0.01em",
            mb: 1,
          }}
        >
          {title}
        </Typography>
        {description ? (
          <Typography
            sx={{
              color: FP.color.textSecondary,
              fontSize: "0.92rem",
              lineHeight: 1.55,
              maxWidth: 720,
              mx: "auto",
              mb: children ? 2.5 : 0,
            }}
          >
            {description}
          </Typography>
        ) : null}
        {children ? (
          <Box
            sx={{
              maxWidth: 760,
              mx: "auto",
              display: "flex",
              alignItems: "stretch",
              gap: 1.25,
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            {children}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
